import { hashString } from "collection-utils";
import { styled } from "sharedUI/styles";

const backgroundColors = [
    "#84CB52",
    "#52BD63",
    "#22AF85",
    "#22AF85",
    "#31B4B4",
    "#AA4FFF",
    "#E346EF",
    "#E346EF",
    "#FF6B62",
    "#FFA530",
];

interface Props {
    size?: "normal" | "large" | "xlarge";
    label: string;
    colorSeed?: string;
}

const sizes: Record<
    NonNullable<Props["size"]>,
    { size: number; radius: number; text: number; containerSize: number }
> = {
    normal: { size: 22, radius: 7, text: 10, containerSize: 28 },
    large: { size: 28, radius: 9, text: 12, containerSize: 28 },
    xlarge: { size: 48, radius: 16, text: 25, containerSize: 48 },
};

interface StyleProps {
    containerSize: number;
    size: number;
    radius: number;
    text: number;
    background: string;
    greyedOut: boolean;
}

export const OrgIconStyle = styled.div<StyleProps>`
    height: ${p => p.containerSize}px;
    width: ${p => p.containerSize}px;
    display: flex;
    align-items: center;
    justify-content: center;

    div {
        width: ${p => p.size}px;
        height: ${p => p.size}px;
        line-height: ${p => p.size}px;
        text-align: center;
        background: ${p => p.background};
        background: ${p => (p.greyedOut ? p.theme.n500 : p.theme.b400)};
        box-shadow: inset 0px -1px 1px rgba(0, 0, 0, 0.05);
        border-radius: ${p => p.radius}px;
        font-size: ${p => p.text}px;
        color: white;
        font-weight: 800;
        transition: background-color ${p => p.theme.transitionBase};
        user-select: none;
    }
`;

function labelToColor(label: string): string {
    return backgroundColors[Math.abs(hashString(label)) % backgroundColors.length];
}

export const OrgIcon = (props: Props) => {
    const { size = "normal", label, colorSeed } = props;
    const background = labelToColor(colorSeed ?? label);
    const initial = (label || "T").substring(0, 1).toUpperCase();
    const greyedOut = size === "normal" || label === "";
    return (
        <OrgIconStyle {...sizes[size]} background={background} greyedOut={greyedOut}>
            <div>{initial}</div>
        </OrgIconStyle>
    );
};
